import { render, staticRenderFns } from "./Notenberechnungsliste.vue?vue&type=template&id=3d695266"
import script from "./Notenberechnungsliste.vue?vue&type=script&lang=js"
export * from "./Notenberechnungsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports